import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, of, forkJoin, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';
import { ScenarioResult } from '../models/scenarioResult.model';
import { InfraService } from './infra.service';


@Injectable()
export class ScenarioExecutionService {
  private configUrl: string;
  private coreAPIUrl: string;
  private pythonConfigUrl :string;

  constructor(private infraService:InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'engagement';
     this.coreAPIUrl = data.WebEndPoint2 ;
      this.pythonConfigUrl=data.PythonURL;
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

    }

  public executeScenario(filteredData: ScenarioResult[],engagementId:number) {
    let reqUrls = [];
    filteredData.forEach(item => {
      reqUrls.push(this.http.post(`${this.pythonConfigUrl}ScenarioExecution`, {'engagementid': engagementId, 'sourcefileid': item.sourceFileId, 'tabid':item.tabId, 'filename': item.fileName}).pipe(catchError(err => of(err))))
    })
    return forkJoin(reqUrls);
  }

  public downloadFileFromBlob(engagementId) {
    return this.http.get(`${this.pythonConfigUrl}downloadfilefromblob?engagementid=${engagementId}`);
  }

  public generateMappingSuggestion(engagementId: number, userId: number) {
    return this.http.post(`${this.coreAPIUrl}ScenarioExecution/GenerateMappingSuggestion`, { 'engagementId': engagementId, 'userId': userId })
  }


  public checkSourceFilesTabsProcessed(engagementId: number) {
    return this.http.get(`${this.coreAPIUrl}engagement/checkSourceFilesTabsProcessed/${engagementId}`)
  }

  public checkMappingStructure(engagementId: number) {
    return this.http.get(`${this.coreAPIUrl}ScenarioExecution/CheckMappingStructure/${engagementId}`);
  }

  public addMessageIntoAzureQueue(engagementId: number, userId: number, regionId: number) {
    return this.http.post(`${this.coreAPIUrl}ScenarioExecution/AddMessageIntoAzureQueue`, { EngagementId: engagementId, UserId: userId, RegionId: regionId });
  }
  public requestAssessmentCancellation(engagementId: number) {
    return this.http.get(`${this.coreAPIUrl}ScenarioExecution/RequestAssessmentCancellation/${engagementId}`);
  }
    private handleError(error: Response) {
      return throwError(()=> error);
    }
}
